import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { FAQS } from "@/data/staticContent";

export default function FAQs() {
  return (
    <div className="max-w-5xl mx-auto px-5 lg:px-8 py-16" data-testid="faqs-page">
      <div className="max-w-3xl mb-10">
        <p className="text-sm font-bold text-purple-600 uppercase tracking-widest mb-3">FAQs</p>
        <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold text-slate-900 leading-[1.05]">
          Answers to <span className="text-blue-600">common questions</span>
        </h1>
        <p className="mt-5 text-slate-600">Everything you need to know before applying. Don't see your question? Reach out through the Contact page.</p>
      </div>

      <Accordion type="single" collapsible className="w-full space-y-3" data-testid="faqs-accordion">
        {FAQS.map((f) => (
          <AccordionItem
            key={f.q}
            value={f.q}
            className="rounded-2xl bg-white border border-slate-100 shadow-sm px-5"
            data-testid={`faq-item-${f.q.slice(0, 30).toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "")}`}
          >
            <AccordionTrigger className="text-left font-display font-bold text-slate-900 hover:no-underline">
              {f.q}
            </AccordionTrigger>
            <AccordionContent className="text-slate-600 leading-relaxed">
              {f.a}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  );
}
